import config from "./aws-config";

let cognitoToken = null;

export function setAuthToken(token) {
  cognitoToken = token;
}

async function graphql(query, variables = {}) {
  const headers = {
    "Content-Type": "application/json",
  };

  // Si un token Cognito est dispo, l'utiliser ; sinon API_KEY
  if (cognitoToken) {
    headers["Authorization"] = cognitoToken;
  } else {
    headers["x-api-key"] = config.appsync.apiKey;
  }

  const res = await fetch(config.appsync.url, {
    method: "POST",
    headers,
    body: JSON.stringify({ query, variables }),
  });

  const json = await res.json();
  if (json.errors) {
    console.error("GraphQL errors:", json.errors);
    throw new Error(json.errors[0].message);
  }
  return json.data;
}

export async function getData() {
  const data = await graphql(`
    query {
      getData {
        communes { id nom }
        moyens { id commune_id categorie_id }
        categories { id nom type }
      }
    }
  `);
  return data.getData;
}

export async function getMoyens() {
  const data = await graphql(`
    query {
      getMoyens {
        moyens { id commune_id categorie_id }
      }
    }
  `);
  return data.getMoyens;
}

export async function getProches(sources, destination) {
  const data = await graphql(
    `
    query GetProches($sources: [ID!]!, $destination: ID!) {
      getProches(sources: $sources, destination: $destination) {
        results { source distance duree }
      }
    }
  `,
    { sources, destination }
  );
  return data.getProches;
}

export async function createMoyen(categorie_id, commune_id) {
  const data = await graphql(
    `
    mutation CreateMoyen($categorie_id: ID!, $commune_id: ID!) {
      createMoyen(categorie_id: $categorie_id, commune_id: $commune_id) {
        id commune_id categorie_id
      }
    }
  `,
    { categorie_id, commune_id }
  );
  return data.createMoyen;
}

export async function deleteMoyen(id) {
  const data = await graphql(
    `
    mutation DeleteMoyen($id: ID!) {
      deleteMoyen(id: $id)
    }
  `,
    { id }
  );
  return data.deleteMoyen;
}
